import {
  OverlayArrow as OverlayArrowBase,
  Tooltip as TooltipBase,
  TooltipTrigger,
  type TooltipProps,
  type TooltipTriggerComponentProps,
} from "react-aria-components";
import { css, cva, cx } from "../../../../styled-system/css";
import { Button } from "./Button";
import { FaCircleInfo } from "react-icons/fa6";

export const HoverInfo = ({
  children,
  iconClassName,
  ...props
}: TooltipTriggerComponentProps & { iconClassName?: string }) => {
  return (
    <TooltipTrigger delay={0} closeDelay={0} {...props}>
      <Button
        variant="contentOnly"
        className={cx(css({ _hover: { cursor: "auto", backgroundColor: "transparent" } }), iconClassName)}
      >
        <FaCircleInfo />
      </Button>
      <Tooltip offset={10}>{children}</Tooltip>
    </TooltipTrigger>
  );
};

export const Tooltip = ({ children, ...props }: TooltipProps) => {
  return (
    <TooltipBase
      {...props}
      className={cx(
        css({
          borderRadius: "light",
          paddingY: "small",
          paddingX: "medium",
          color: "white",
          fontSize: "medium",
          fontWeight: "500",
          backgroundColor: "royalPurple",
        }),
      )}
    >
      {(values) => (
        <>
          <OverlayArrow />
          {typeof children === "function" ? children(values) : children}
        </>
      )}
    </TooltipBase>
  );
};

export function OverlayArrow({ color }: { color?: "white" }) {
  return (
    <OverlayArrowBase
      className={cva({
        base: {
          "& svg": {
            display: "block",
            fill: "royalPurple",
          },
          "&[data-placement=bottom]": {
            marginTop: "28px",
            "& svg": {
              transform: "rotate(180deg)",
            },
          },
          "&[data-placement=left] svg": {
            transform: "rotate(-90deg)",
          },
          "&[data-placement=right] svg": {
            transform: "rotate(90deg)",
          },
        },
        variants: {
          colorScheme: {
            white: {
              "& svg": {
                fill: "white",
                stroke: "grey",
              },
            },
          },
        },
      })({ colorScheme: color })}
    >
      <svg width={8} height={8} viewBox="0 0 8 8">
        <path d="M0 0 L4 4 L8 0" />
      </svg>
    </OverlayArrowBase>
  );
}
